const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/Arzt.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import _ from 'lodash';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ArztBlock, ArztFieldsConfig } from 'App/components/eCheckin/components/fields/ArztBlock';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { EinweisenderArztField } from './fields/EinweisenderArztField';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import { YesNoField } from 'App/components/eCheckin/components/fields/YesNoField';
import { Divider } from '@mui/material';

type ArztBlockConfig = {
    addressFieldsConfig?: AddressFieldsConfig;
    arztFieldConfig?: ArztFieldsConfig;
};

const sharedArztConfig: ArztBlockConfig = {
    arztFieldConfig: {
        tel: { included: false },
    },
    addressFieldsConfig: {
        additionalInfo: { included: false },
        country: { included: false },
    },
};

export const Arzt = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const eCheckinSectionRef = useCIS4m(ref);
    const formData = useCIS4mData();

    const PATH_KEIN_HAUSARZT = createFieldPath(path, 'keinHausarzt');
    const PATH_ZUWEISER = createFieldPath(path, 'assignment');
    const PATH_ZUWEISER_PRAXIS = createFieldPath(path, 'assignPraxis');
    const PATH_PRAXIS = createFieldPath(path, 'praxis');
    const PATH_MED_REPORT = createFieldPath(path, 'medreport');
    const PATH_ASSIGN_MED_REPORT = createFieldPath(path, 'assignMedreport');
    const PATH_ASSIGNMENT_DOCTOR = createFieldPath(path, 'assignmentDoctor');

    const hasKeinHausarzt = _.get(formData, PATH_KEIN_HAUSARZT) === '1';
    const isOtherAssigner = _.get(formData, PATH_ZUWEISER) === 'andere';

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.keinHausarzt} path={PATH_KEIN_HAUSARZT} />
            <CIS4mBlock hidden={hasKeinHausarzt}>
                <CIS4mTextField label={textMap.praxis} path={PATH_PRAXIS} />
                <ArztBlock
                    basePath={path}
                    fieldsConfig={sharedArztConfig.arztFieldConfig}
                    addressFieldsConfig={sharedArztConfig.addressFieldsConfig}
                    required
                />
                <YesNoField label={textMap.medReportGP} path={PATH_MED_REPORT} required />
            </CIS4mBlock>
            <Divider />
            <EinweisenderArztField label={textMap.assigner} path={PATH_ZUWEISER} required />
            <CIS4mBlock hidden={!isOtherAssigner}>
                <CIS4mTextField label={textMap.assignPraxis} path={PATH_ZUWEISER_PRAXIS} />
                <ArztBlock
                    basePath={PATH_ASSIGNMENT_DOCTOR}
                    fieldsConfig={sharedArztConfig.arztFieldConfig}
                    addressFieldsConfig={sharedArztConfig.addressFieldsConfig}
                    required
                />
                <YesNoField label={textMap.medReportAssigner} path={PATH_ASSIGN_MED_REPORT} required />
            </CIS4mBlock>
        </ECheckinSection>
    );
});

Arzt.displayName = 'Arzt';

export default Arzt;
